export default  [
    {
        id: 'FEAT-0001',
        name: 'appConsent',
        description: 'Add consent and terms of use',
        enabled: true
    },
    {
        id: 'FEAT-0002',
        name: 'appPMO',
        description: 'Add PMO tools (Budgetrequest, Projectrequest, etc)',
        enabled: true
    },{
        id: 'FEAT-0003',
        name: 'appDFHB',
        description: 'Add Request fpr extra budget (DFHB)',
        enabled: true
    },{
        id: 'HEADER-0001',
        name: 'appHEADER_ShowEnv',
        description: 'Show environment in header',
        enabled: true
    },{
        id: 'HEADER-0002',
        name: 'appHEADER_ShowworkspaceId',
        description: 'Show environment in header',
        enabled: true
    },{
        id: 'HEADER-0003',
        name: 'appHEADER_ShowworkspaceId_Auto',
        description: 'Show environment in header disabled when only one workspaceId',
        enabled: true
    }, {
        id: 'HOME-0001',
        name: 'appHOME_ShowGraphics',
        description: 'Show graphics on Home page',
        enabled: true
    }, {
        id: 'FEAT-0007',
        name: 'appAIStudio',
        description: 'Enable AI Document Scanner (upload PDF, extract structured data)',
        enabled: true
    }
]

// NOTE: USE_DYNAMIC_FORM_BUDGET and USE_DYNAMIC_FORM_BUDGETLINE feature flags
// have been removed. Render mode (static/dynamic/custom) is now managed via
// the DB table dbo.ui_render_mode_config, controlled through the Make admin UI.
// See: app/uptk/core/hooks/useRenderMode.ts and docs/UI-RENDER-MODE-API-SPEC.md

